module.exports = __webpack_public_path__ + "ag.43f5ec5f4daa88ac5c35.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ag.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ag.svg
// module chunks = styles